module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/qa/female_specialist-95be1e04cfb27e90ded00b3100fec115.png";